import type { PageMeta } from "shared/utils";

export enum SupportTicketStatus {
  NEW = "new",
  IN_PROGRESS = "in_progress",
  ANSWERED = "answered",
  CLOSED = "closed",
}

export interface SupportTicket {
  id: number;
  subject: string;
  status: SupportTicketStatus;
  created_at: string;
  updated_at: string;
  can_reply: boolean;
}

export interface SupportTicketsFilter {
  status?: SupportTicketStatus;
}

export interface SupportTicketsPage extends PageMeta {
  tickets: SupportTicket[];
}

export interface CreateTicketRequest {
  subject: string;
  body: string;
}

export type CreateTicketResponse = Pick<
  SupportTicket,
  "id" | "subject" | "status" | "created_at"
>;

export interface ReplyTicketRequest {
  ticketId: number;
  body: string;
}

export interface SupportTicketMessage {
  id: number;
  // Swagger пишет "admin", стенд фактически отдаёт "support".
  author_type: "user" | "support";
  body: string;
  created_at: string;
}

export interface SupportTicketDetail {
  ticket: SupportTicket;
  messages: SupportTicketMessage[];
}

export interface CloseTicketResponse {
  id: number;
  status: SupportTicketStatus.CLOSED;
  can_reply: false;
}
